<template>
  <section>
    <p class="headline">
      <img src="/images/logo_escort.svg">
      <span>Plan Search</span>
    </p>

    <div class="column">
      <div>
        <p class="js-height">タイプを選択してください。</p>
        <ul>
          <li v-for="type in types" :key="type.id">
            <input
              type="checkbox"
              v-model="checkedTypes"
              :value="type.name"
              :id="type.id"
            >
            <label :for="type.id">
              <span class="en"><b>{{ type.name }}</b>type</span>
              <span class="ja">{{ type.category }}</span>
            </label>
          </li>
        </ul>
      </div>
      <div>
        <p class="js-height">パッケージ・グレードを<br>選択してください。</p>
        <ul>
          <li v-for="grade in grades" :key="grade.id">
            <input
              type="checkbox"
              v-model="checkedGrades"
              :value="grade.name"
              :id="grade.id"
            >
            <label :for="grade.id" :class="{ single: !grade.package }">
              <span class="en">{{ grade.type }}</span>
              <span class="ja">グレード</span>
              <br class="is-tb">
              <span class="en withPackage" v-if="grade.package">{{ grade.package }}</span>
              <span class="ja" v-if="grade.package">パッケージ</span>
            </label>
          </li>
        </ul>
      </div>
      <!-- <div>
        <p class="js-height">サイズを選択してください。</p>
        <ul>
          <li v-for="size in sizes" :key="size.id">
            <input
              type="checkbox"
              v-model="checkedSizes"
              :value="size.name"
              :id="size.id"
            >
            <label :for="size.id">
              <span class="en">{{ size.name }}</span>
              <span class="ja">サイズ</span>
            </label>
          </li>
        </ul>
      </div> -->
    </div>

    <div class="search-count">
      <p>計<span>{{ filteredItemList.length }}</span>プランが見つかりました</p>
    </div>

    <ul class="search-result">
      <li
        v-for="(product, index) in filteredItemList"
        :key="product.id"
      >
        <div class="thumb">
          <img :src="product.thumbnail" alt="製品サムネイル" @click="openModal(index)">
          <div @click="openModal(index)">
            <div>
              <p class="type"><span v-for="(item, index) in product.type" :key="index">{{ item }}</span>type</p>
              <p class="gradeType"><span>{{ product.gradeType }}</span>グレード</p>
              <p class="grade" v-if="product.hasPackage"><span v-for="(item, index) in product.grade" :key="index">{{ item }}</span>パッケージ</p>
              <p class="size"><span v-for="(item, index) in product.size" :key="index">{{ item }}</span></p>
            </div>
          </div>
        </div>
        <!-- <dl class="price">
          <dt>本体価格（基本仕様）</dt>
          <dd>
            <template v-if="product.basicSize"><span class="another">{{ product.basicSize }}</span></template>
            <span>{{ product.basicPrice }}</span>
            <template v-if="product.anotherSize">
              <br>
              <span class="another">{{ product.anotherSize }}</span>
              <span>{{ product.anotherBasicPrice }}</span>
            </template>
            <template v-if="product.anotherSize2">
              <br>
              <span class="another">{{ product.anotherSize2 }}</span>
              <span>{{ product.anotherBasicPrice2 }}</span>
            </template>
          </dd>
        </dl> -->

        <!--  ※20260729 価格改定に伴い価格は全て非表示
        <dl class="option-price">
          <dt>写真のセット価格</dt>
          <dd>
            <template v-if="product.basicSize"><span class="another">{{ product.basicSize }}</span></template>
            <span>{{ product.totalPrice }}</span><span class="beforeTax">（税抜）</span>
            <template v-if="product.anotherSize">
              <br>
              <span class="another">{{ product.anotherSize }}</span>
              <span>{{ product.anotherTotalPrice }}</span><span class="beforeTax">（税抜）</span>
            </template>
            <template v-if="product.anotherSize2">
              <br>
              <span class="another">{{ product.anotherSize2 }}</span>
              <span>{{ product.anotherTotalPrice2 }}</span><span class="beforeTax">（税抜）</span>
            </template>
          </dd>
        </dl>
         -->
        <transition name="fade">
          <div class="modal" v-if="product.modal">
            <div class="filter" @click="closeModal(index)"></div>
            <div class="content">
              <div class="thumbnail">
                <img :src="product.thumbnail">
                <div>
                  <div>
                    <p class="type"><span v-for="(item, index) in product.type" :key="index">{{ item }}</span>type</p>
                    <p class="gradeType"><span>{{ product.gradeType }}</span>グレード</p>
                    <p class="grade" v-if="product.hasPackage"><span v-for="(item, index) in product.grade" :key="index">{{ item }}</span>パッケージ</p>
                    <p class="size"><span v-for="(item, index) in product.size" :key="index">{{ item }}</span></p>
                  </div>
                </div>
              </div>
              <div class="spec">
                <div class="list plan_search">
                  <dl>
                    <dt>床色</dt>
                    <dd>{{ product.floorColor }}</dd>
                  </dl>
                  <dl>
                    <dt>アクセント壁色</dt>
                    <dd>{{ product.wallColor }}</dd>
                  </dl>
                  <dl>
                    <dt>周囲壁</dt>
                    <dd>{{ product.surroundingWall }}</dd>
                  </dl>
                  <dl>
                    <dt>天井色</dt>
                    <dd>{{ product.ceilingColor }}</dd>
                  </dl>
                  <dl>
                    <dt>換気扇・乾燥機種</dt>
                    <dd>{{ product.ventilation }}</dd>
                  </dl>
                  <dl>
                    <dt>ドア種</dt>
                    <dd>{{ product.doorType }}</dd>
                  </dl>
                  <dl>
                    <dt>浴槽形状</dt>
                    <dd>{{ product.bathtubShape }}</dd>
                  </dl>
                  <dl>
                    <dt>浴槽材質</dt>
                    <dd>{{ product.bathtubMaterial }}</dd>
                  </dl>
                  <dl>
                    <dt>浴槽色</dt>
                    <dd>{{ product.bathtubColor }}</dd>
                  </dl>
                  <dl>
                    <dt>エプロン色・カウンター色</dt>
                    <dd>{{ product.apronColor }}・{{ product.counterColor }}</dd>
                  </dl>
                  <dl>
                    <dt>水栓金具・洗場水栓</dt>
                    <dd>{{ product.waterPanel }}</dd>
                  </dl>
                  <dl>
                    <dt>シャワー種</dt>
                    <dd>{{ product.showerType }}</dd>
                  </dl>
                  <dl>
                    <dt>鏡</dt>
                    <dd>{{ product.mirrorType }}</dd>
                  </dl>
                  <dl>
                    <dt>照明</dt>
                    <dd>{{ product.lightingType }}</dd>
                  </dl>
                  <dl>
                    <dt>手摺</dt>
                    <dd>{{ product.handrail }}</dd>
                  </dl>
                  <dl>
                    <dt>浴槽横手摺</dt>
                    <dd>{{ product.sideHandrail }}</dd>
                  </dl>
                  <dl>
                    <dt>ドア横縦手摺</dt>
                    <dd>{{ product.doorHandrail }}</dd>
                  </dl>
                  <dl>
                    <dt>タオル掛け</dt>
                    <dd>{{ product.towel }}</dd>
                  </dl>
                  <dl>
                    <dt>収納棚種</dt>
                    <dd>{{ product.rackType }}</dd>
                  </dl>
                  <dl>
                    <dt>風呂蓋</dt>
                    <dd>{{ product.bathtubLid }}</dd>
                  </dl>
                  <dl>
                    <dt>その他</dt>
                    <dd>{{ product.other }}</dd>
                  </dl>
                </div>

                <!--  ※20260729 価格改定に伴い価格は全て非表示
                <div class="notation">
                  <dl>
                    <dt>本体希望小売価格</dt>
                    <dd>
                      <template v-if="product.basicSize"><span class="another">{{ product.basicSize }}</span></template>
                      <span>{{ product.basicPrice }}</span>
                      <template v-if="product.anotherSize">
                        <br>
                        <span class="another">{{ product.anotherSize }}</span>
                        <span>{{ product.anotherBasicPrice }}</span>
                      </template>
                      <template v-if="product.anotherSize2">
                        <br>
                        <span class="another">{{ product.anotherSize2 }}</span>
                        <span>{{ product.anotherBasicPrice2 }}</span>
                      </template>
                    </dd>
                  </dl>
                  <dl class="option">
                    <dt>オプション合計価格</dt>
                    <dd><span>{{ product.optionPrice }}</span></dd>
                  </dl>
                  <dl class="option">
                    <dt>写真のセット価格</dt>
                    <dd>
                      <template v-if="product.basicSize"><span class="another">{{ product.basicSize }}</span></template>
                      <span>{{ product.totalPrice }}</span>
                      <template v-if="product.anotherSize">
                        <br>
                        <span class="another">{{ product.anotherSize }}</span>
                        <span>{{ product.anotherTotalPrice }}</span>
                      </template>
                      <template v-if="product.anotherSize2">
                        <br>
                        <span class="another">{{ product.anotherSize2 }}</span>
                        <span>{{ product.anotherTotalPrice2 }}</span>
                      </template>
                    </dd>
                  </dl>
                  <div class="addition02">
                    <p class="addition02__text">
                      &lowast;価格は税抜/工事費別<template v-if="product.thumbnailSize">、画像は{{ product.thumbnailSize }}</template><br>
                      <template v-if="product.noteDetachedOrComplex">{{ product.noteDetachedOrComplex }}</template>
                    </p>
                  </div>
                </div>
                -->
                
                
                <div class="close is-pc" @click="closeModal(index)">
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div class="close is-tb" @click="closeModal(index)">
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </transition>
      </li>
    </ul>
  </section>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'search',
  data() {
    return {
      setHeight: 0,
      checkedTypes: [],
      checkedGrades: [],
      // checkedSizes: [],
      types: [
        { id: 'wtype', name: 'W', category: 'ワイドタイプ' },
        { id: 'btype', name: 'B', category: 'ベーシックタイプ' }
      ],
      grades: [
        { id: 'standard', name: 'Standard', type: 'Standard' },
        { id: 'safety', name: 'Safety', type: 'Standard', package: 'Safety' },
        { id: 'eco', name: 'Eco', type: 'Standard', package: 'Eco' },
        { id: 'easy', name: 'Easy', type: 'Standard', package: 'Easy' },
        { id: 'simple', name: 'Simple', type: 'Simple' },
        { id: 'light', name: 'light', type: 'light' }
      ],
      // sizes: [
      //   { id: 'size3', name: '1616' },
      //   { id: 'size4', name: '1216' },
      // ],
      products: this.$store.state.catalogList
    }
  },
  mounted() {
    // 初回ロード
    this.alignHeight();

    // リサイズ時
    window.addEventListener('resize', lodash.debounce(() => {
      this.alignHeight()
    }, 300));

    // component削除時に棄却
    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("resize", this.alignHeight);
    });
  },
  computed: {
    // タイプ別ソート
    filteredTypeList() {
      if(this.checkedTypes.length === 0) return this.products;
      return lodash.filter(this.products, item => {
        return lodash.intersection(item.type, this.checkedTypes).length;
      });
    },
    // グレード別ソート
    filteredGradeList() {
      if(this.checkedGrades.length === 0) return this.products;
      return lodash.filter(this.products, item => {
        return lodash.intersection(item.grade, this.checkedGrades).length;
      });
    },
    // マッピング
    filteredItemList() {
      return lodash.intersection(this.filteredTypeList, this.filteredGradeList);
    }
  },
  methods: {
    // 高さを揃える
    alignHeight() {
      const targetElements = Array.from(document.querySelectorAll('.js-height'));
      this.setHeight = 0;

      // 高さの最大値を取得
      targetElements.forEach(element => {
        element.style.height = '';

        if(this.setHeight < element.clientHeight) {
          this.setHeight = element.clientHeight;
        }
      });

      // 最大値の代入
      targetElements.forEach(element => {
        element.style.height = `${ this.setHeight }px`;
      });
    },
    // モーダルの開閉
    openModal(index) {
      this.filteredItemList[index].modal = true;
    },
    closeModal(index) {
      this.filteredItemList[index].modal = false;
    }
  }
}
</script>

<style scoped lang="scss">
input {
  display: none;

  &:checked + label {
    border: 2px solid #000;
  }

  + label {
    cursor: pointer;
    padding: 12px 0;
    background: $colorBeige;
    display: block;
    border: 2px solid $colorBeige;
    text-align: center;
    box-sizing: border-box;
    transition: $fastTransition;
    margin-bottom: 8px;

    @include mq(tb) {
      padding: 12px 0 4px;
    }
  }
}

@include mq(tb) {
  .single {
    padding: 21px 0 13px !important;
  }
}

section {
  width: 100%;
  background: url(/images/bg_search.jpg) center top / cover no-repeat;
  padding: 100px 4.78vw 0;
}

.headline {
  text-align: center;

  > * {
    vertical-align: middle;
  }

  img {
    width: 213px;

    @include mq(tb) {
      width: 84px;
      vertical-align: -9px;
    }
  }

  span {
    font-size: 62px;
    font-family: $bellFont;
    margin-left: 48px;

    @include mq(tb) {
      font-size: 27px;
      margin-left: 16px;
    }
  }
}

.column {
  display: flex;
  justify-content: center;
  margin-top: 90px;

  @include mq(tb) {
    display: block;
    margin-top: 24px;
  }

  > div {
    width: calc(100% / 2 - 7.75vw);
    text-align: center;
    margin: 0 1.87vw;

    @include mq(tb) {
      width: 100%;
      margin: 0;

      + div {
        margin-top: 24px;

        ul {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -4px;
        }

        li {
          width: calc(100% / 2 - 8px);
          margin: 0 4px;
        }
      }
    }
  }

  p {
    margin-bottom: 39px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.75;

    @include mq(tb) {
      font-size: 13px;
      margin-bottom: 16px;

      br {
        display: none;
        margin-bottom: 16px;
      }
    }
  }

  span + span {
    margin-left: 12px;
  }

  .en {
    font-family: $bellFont;
    font-size: 28px;
    vertical-align: -4px;

    @include mq(tb) {
      font-size: 18px;
      vertical-align: 1px;
    }

    b {
      font-size: 52px;
      vertical-align: middle;
      margin-right: 2px;

      @include mq(tb) {
        font-size: 41px;
      }
    }
  }

  .ja {
    font-size: 15px;
    font-weight: bold;
    vertical-align: -1px;

    @include mq(tb) {
      font-size: 12px;
      vertical-align: 2px;
    }
  }

  .withPackage {
    margin-left: 8px;

    @include mq(tb) {
      margin-left: 0;
    }
  }
}

.search-count {
  background: #fff;
  margin-top: 42px;
  padding: 12px 0;
  text-align: center;

  @include mq(tb) {
    margin-top: 24px;
  }

  p {
    font-size: 21px;
    font-weight: bold;

    @include mq(tb) {
      font-size: 13px;
    }

    span {
      font-family: $bellFont;
      font-size: 55px;
      vertical-align: -6px;
      margin: 0 12px;

      @include mq(tb) {
        font-size: 31px;
        vertical-align: -3px;
        margin: 0 8px;
      }
    }
  }
}

.search-result {
  display: flex;
  flex-wrap: wrap;
  margin: 56px -1.6vw 0;

  @include mq(tb) {
    margin: 24px -8px 0;
  }

  > li {
    width: calc(100% / 3 - 3.2vw);
    margin: 0 1.6vw 72px;

    @include mq(tb) {
      width: calc(100% / 2 - 16px);
      margin: 0 8px 24px;
    }
  }

  .thumb {
    position: relative;
    margin-bottom: 16px;
    cursor: pointer;

    img {
      width: 100%;
    }

    > div {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: $colorBeige;
      width: 160px;
      height: 160px;
      text-align: center;
      @include flexCentering;

      @include mq(tb) {
        width: 120px;
        height: 120px;
      }
    }

    p + p {
      margin-top: 10px;

      @include mq(tb) {
        margin-top: 4px;
      }
    }

    .type {
      font-family: $bellFont;
      font-size: 18px;

      @include mq(tb) {
        font-size: 13px;
      }

      span {
        font-size: 34px;
        margin-right: 2px;
        vertical-align: middle;

        @include mq(tb) {
          font-size: 27px;
        }
      }
    }

    .gradeType {
      font-weight: bold;
      font-size: 13px;

      @include mq(tb) {
        font-size: 10px;
      }

      span {
        font-family: $bellFont;
        font-size: 20px;
        margin-right: 5px;

        @include mq(tb) {
          font-size: 14px;
        }
      }
    }

    .grade {
      font-weight: bold;
      font-size: 11px;

      @include mq(tb) {
        font-size: 10px;
      }

      span {
        font-family: $bellFont;
        font-size: 15px;
        margin-right: 4px;

        @include mq(tb) {
          font-size: 12px;
        }
      }
    }

    .size {
      font-family: $bellFont;
      font-size: 17px;

      @include mq(tb) {
        font-size: 14px;
      }

      span + span {
        position: relative;

        &::before {
          content: '/';
        }
      }
    }
  }

  .price {
    display: flex;
    justify-content: space-between;
    font-weight: bold;

    + .price {
      margin-top: 8px;
    }

    dt {
      font-size: 12px;

      @include mq(tb) {
        font-size: 10px;
        font-weight: normal;
      }
    }

    dd {
      font-size: 12px;
      margin-top: -5px;
      text-align: right;

      @include mq(tb) {
        font-size: 10px;
        margin-top: 4px;
      }

      span {
        font-size: 19px;
        line-height: 24px;
        font-family: $bellFont;
      }

      .another {
        font-size: 16px;
        margin-right: 12px;
      }
    }
  }

  .option-price {
    margin-top: 15px;
    @extend .price;

    @include mq(sp) {
      display: block;
    }

    dt {
      font-size: 10px;

      @include mq(sp) {
        text-align: right;
      }
    }

    dd {
      font-size: 10px;
      margin-top: -6px;

      @include mq(sp) {
        margin-top: 7px;
      }

      span {
        font-size: 17px;
        &.beforeTax{
          font-size: 12px !important;
          font-family: $baseFont !important;
        }
      }
    }
  }

}


.modal {
  @include catalogModal;
}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
  transition: $fastTransition;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.modal{
  .content{
    .spec{

      .list{
        &.plan_search{
          @include mq(tb) {
            display: none;
          }
        }
      }
      .notation{
        dl, dl.option{
          dt{
            width: 140px;  
            text-align: right;
            margin-right: 0;

            @include mq(tb) {
              width: 35% !important;
            }
          }
        }
      }
    }
  }
}
</style>
